<script>

import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Utils from '../../common/Utils';
import Operations from '../../components/tank-management/operations/Operations.vue';
import Calculator from '../../components/tank-management/calculator/Calculator.vue';

export default{
    props: [],
    components: {
        TabView, TabPanel,
        Operations,
        Calculator
    },
    data(){
        return{
            activeTab: 0
        }
    },
    mounted(){
        this.$store.dispatch('security/setNavbarTitle', 'tankOperations.page_title');
    },
    computed: {
        utils(){
            return Utils;
        }
    },
    methods: {
        populateCalculator(data){
            this.$refs.calculator.populateInput(data);
            this.activeTab = 1;
        }
    }
};

</script>

<template>
    <main>
        <TabView v-model:activeIndex="activeTab">
            <TabPanel :header="$t('tankOperations.tabOperations')">
                <Operations @populate-calculator="populateCalculator" />
            </TabPanel>
            <TabPanel :header="$t('tankCalculator.calculator')">
                <Calculator ref="calculator" :disableImport="true" />
            </TabPanel>
        </TabView>
    </main>
</template>
        